import * as react from "react";
import { empty, singleton, append, delay, toList } from "../../../fable_modules/fable-library-js.4.19.0/Seq.js";
import { value as value_1, defaultArg } from "../../../fable_modules/fable-library-js.4.19.0/Option.js";

export const navigationArrow = react.createElement("img", {
    className: "navigation-arrow",
    src: "arrow_32x32.svg",
});

export function bfsTile(title, titleAction, icon, body, footer) {
    const children_18 = toList(delay(() => {
        let children_6, children_4;
        return append(singleton((children_6 = [react.createElement("div", {
            className: "bfs-tile-header-title",
        }, title), (children_4 = [defaultArg(titleAction, react.createElement("span", {}))], react.createElement("div", {
            className: "bfs-tile-header-option",
        }, ...children_4))], react.createElement("div", {
            className: "card-header",
        }, ...children_6))), delay(() => {
            let children_12;
            return append(singleton((children_12 = toList(delay(() => {
                let children_8;
                return append((icon != null) ? singleton((children_8 = [value_1(icon)], react.createElement("div", {
                    className: "bfs-tile-icon-container",
                }, ...children_8))) : empty(), delay(() => singleton(react.createElement("div", {
                    className: "bfs-tile-content",
                }, body))));
            })), react.createElement("div", {
                className: "card-body",
            }, ...children_12))), delay(() => {
                let children_16, children_14;
                return (footer != null) ? singleton((children_16 = [(children_14 = [value_1(footer)], react.createElement("div", {
                    className: "footer-right",
                }, ...children_14))], react.createElement("div", {
                    className: "card-footer",
                }, ...children_16))) : empty();
            }));
        }));
    }));
    return react.createElement("div", {
        className: "flat-card bfs-tile-card",
    }, ...children_18);
}

export function headlessTile(body) {
    let children_2;
    const children_4 = [(children_2 = [react.createElement("div", {
        className: "bfs-tile-content",
    }, body)], react.createElement("div", {
        className: "card-body",
    }, ...children_2))];
    return react.createElement("div", {
        className: "flat-card bfs-tile-card",
    }, ...children_4);
}

//# sourceMappingURL=Tile.fs.js.map
